module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-dialog"
  }, [_c('v-modal', {
    attrs: {
      "show": _vm.show,
      "headerVisible": false,
      "size": 'm'
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return undefined
      },
      proxy: true
    }, {
      key: "body",
      fn: function() {
        return [_c('div', {
          staticClass: "notifit_error_message"
        }, [_c('div', {
          staticClass: "site-menu-icon modal-title-icon modals-icon"
        }, [_c('i', {
          staticClass: "icon-info",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "general-nofi-modal-title"
        }, [_vm._v("\n                    " + _vm._s(_vm.message) + "\n                ")]), _vm._v(" "), _vm._t("content")], 2)]
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function() {
        return [_c('p', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-success",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.okClicked.apply(null, arguments)
            }
          }
        }, [_vm._v("OK")]), _vm._v(" "), (_vm.isCancelBtnVisible) ? _c('button', {
          staticClass: "btn btn-primary",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancelClicked.apply(null, arguments)
            }
          }
        }, [_vm._v("CANCEL")]) : _vm._e()])]
      },
      proxy: true
    }], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d055c966!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/error-dialog.vue
// module id = 1277
// module chunks = 12 14 18 19 21 35